import React, {Component} from 'react'
import WithAuthentication from "./WithAuthentication"
import {Redirect, withRouter} from "react-router-dom"
import createApiServices from '../../services/api/createApiServices'
import {getRefreshToken, logoutUser} from '../../services/AuthServices'
import {refreshToken} from "../../services/api/UserService"
import {parseJwt} from "../../helpers/parseToken"
import * as AuthServices from "../../services/AuthServices"
import {getLocalData} from "../../services/StorageServices"

class EnsureLoggedIn extends Component {
    state = {
        load: false
    }
    _api = createApiServices()

    _handleRefreshToken = async () => {
        try {
            const payload = {
                refreshToken: getRefreshToken()
            }

            const {data, success, message} = await refreshToken(payload)

            if (!success) {
                logoutUser(message || '')
            }

            const {accessToken, roles, refreshToken: refreshTok} = data

            const timeExp = parseJwt(accessToken).exp - parseJwt(accessToken).iat

            AuthServices.setAccessToken(accessToken)
            AuthServices.setUserData(roles)
            AuthServices.setRefreshToken(refreshTok)
            AuthServices.setTimeExp((timeExp - 300) * 1000 + new Date().getTime())
            this.setState({
                load: true
            })
        } catch (e) {
            logoutUser(e.message || '')
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({load: false})

        const getTimeExp = getLocalData('timeExp')

        if (new Date().getTime() > getTimeExp && getRefreshToken()) {
            this._handleRefreshToken()
        } else {
            this.setState({
                load: true
            })
        }
        this._api.subscribeErrorRequest(error => {
            const {status, data} = error
            if (status === 403 || status === 401) {
                const {message} = Object.assign({}, data)
                logoutUser(message || '')
            }
        })
    }

    componentWillMount() {
        const getTimeExp = getLocalData('timeExp')

        if (new Date().getTime() > getTimeExp && getRefreshToken()) {
            this._handleRefreshToken()
        } else {
            this.setState({
                load: true
            })
        }
        this._api.subscribeErrorRequest(error => {
            const {status, data} = error

            if (status === 403 || status === 401) {
                const {message} = Object.assign({}, data)
                logoutUser(message || '')
            }
        })
    }

    render() {
        const {location} = this.props

        return (
            <WithAuthentication>
                {
                    ({isAuthenticated}) => {
                        return this.state.load ? isAuthenticated ? this.props.children : <Redirect to={{
                            pathname: "/login",
                            state: {referrer: location.pathname + (location.search || '')}
                        }}/> : <div className="text-center bg-white">Đang tải...</div>
                    }
                }
            </WithAuthentication>
        )
    }
}

export default withRouter(EnsureLoggedIn)
